export const MAX_SMS_CHARACTER_COUNT = 350;

export const campaingLinkModeOptions = (
    t: (key: string, params?: { number: number }) => string
) => ({
    none: t('campaign.never'),
    created: t('campaign.created'),
    dispatched: t('campaign.dispatched'),
    underway: t('campaign.underway'),
    completed: t('campaign.complete'),
    task0: t('campaign.taskNumber', { number: 1 }),
    task1: t('campaign.taskNumber', { number: 2 }),
    task2: t('campaign.taskNumber', { number: 3 }),
    task3: t('campaign.taskNumber', { number: 4 }),
    task4: t('campaign.taskNumber', { number: 5 })
});

type KeyValue = { [key: string]: string };

export const templateData: { [key: string]: KeyValue } = {
    job: {
        mock: 'ORDER000123',
        name: 'order number'
    },
    name: {
        mock: 'John Smith',
        name: 'customer name'
    },
    link: {
        mock: 'https://trckl.co/BXHwb27626rebw',
        name: 'tracking link'
    },
    site: {
        mock: 'Big Kahuna Burger',
        name: 'site'
    }
};
